import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { useCallback } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { Product } from '../consts';
import styled from './Theme';
const StyledSelect = styled(UISelect).withConfig({
  displayName: "ProductSelect__StyledSelect",
  componentId: "z25oy6-0"
})(["& > div{background-color:", " !important;}"], props => props.theme.colors.OLAF);

const ProductSelect = ({
  value,
  onChange
}) => {
  const productOptions = Object.values(Product).map(product => ({
    value: product,
    text: I18n.text(`connectDotCom.hubs.${product}`)
  }));
  const handleChange = useCallback(e => {
    onChange(e.target.value);
  }, [onChange]);
  return /*#__PURE__*/_jsx(StyledSelect, {
    value: value,
    multi: true,
    options: productOptions,
    onChange: handleChange,
    placeholder: I18n.text('connectDotCom.chooseProducts')
  });
};

export default ProductSelect;